import { SET_SOURCE_IMPORT_HISTORY } from "./actions";

export default {
  [SET_SOURCE_IMPORT_HISTORY](state, payload) {
    state.sourceRatingImport = payload;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};
